// extracted by css-extract-rspack-plugin
export default {"cls1":"TagSelector-cls1_BjQ","cls2":"TagSelector-cls2_Bxh TagSelector-cls1_BjQ"};